import React from "react";
import Navbar from "../components/FrontPages/Common/Navbar";
import RealSolutions from "../components/FrontPages/Common/RealSolutions";
import Cta from "../components/FrontPages/Common/Cta";
import Footer from "../components/FrontPages/Common/Footer";
import PageBanner from "../components/FrontPages/Common/PageBanner";


const Solutions = () => {
  return (
    <>
      <div className="fp-wrapper">
        <Navbar />

        <PageBanner />

        <RealSolutions />

        <Cta />

        <Footer />
      </div>
    </>
  );
};

export default Solutions;
